import { createPortal } from "react-dom";

/* This component is used to render the tooltip in a portal, 
which allows it to be rendered outside of the parent component's DOM hierarchy. */
const TooltipWrapper = ({ children }) => {
  return createPortal(children, document.body);
};

export default TooltipWrapper;
